import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListTextWrap = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33325 10H14.1666C15.5473 10 16.6666 11.1193 16.6666 12.5C16.6666 13.8807 15.5473 15 14.1666 15H9.16659M3.33325 15H5.41659M3.33325 5H16.6666M11.5095 17.5C10.687 16.8831 9.94427 16.1675 9.29775 15.3696C9.2103 15.2617 9.16659 15.1309 9.16659 15M11.5095 12.5C10.687 13.1169 9.94427 13.8325 9.29775 14.6304C9.21031 14.7383 9.16659 14.8691 9.16659 15",
		stroke: "#3F3F46",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgListTextWrap);
export default ForwardRef;
